<template>
  <div class="index">
    <van-nav-bar title="查看问卷" fixed left-arrow @click-left="$router.push('/my')" style="z-index: 9999999" />
    <div class="head"><img src="@/assets/image/my/组 634@2x.png" /></div>
    <div>
      <ul v-if="list.length != 0" class="my-ul">
        <li class="my-li" v-for="(item, index) in list" :key="index">
          <div class="my-li-head">
            <div class="my-li-head-title">{{ index + 1 }}、淋巴瘤CAR-T治疗全程管理项目问卷</div>
          </div>
          <div class="my-li-time">
            <div class="my-li-time-img"><img src="@/assets/image/my/icon/time.png"></div>
            <div class="my-li-time-name">{{ item.created_at }}</div>
          </div>
          <div class="my-li-box">
            <div class="my-li-box-item" @click="$router.push({ path: 'look', query: { id: item.id } })">
              <div class="my-li-box-item-img"><img src="@/assets/image/my/icon/cha.png"></div>
              <div class="my-li-box-item-name">查看</div>
            </div>
          </div>
        </li>
      </ul>
      <van-empty v-else description="暂无数据" style="position: absolute;top: 0px;left: 50%;transform: translateX(-50%);" />
    </div>
  </div>
</template>      
<script>
export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getForm()
  },
  mounted() { },
  methods: {
    async getForm() {
      const { data: data } = await this.$http.get(
        "medical/survey-list",
      );
      this.list = data.data
    },
  },
} 
</script>  
<style lang="less" scoped> .index {
   position: relative;
   //  margin-bottom: 50px;
   margin-bottom: 20px;
 }

 .head {
   width: 108%;
   position: absolute;
   top: -20px;
   left: -4%;
 }

 .my-ul {
   position: relative;
   z-index: 9;
   margin-top: 15px;

   .my-li {
     box-shadow: 0px 3px 8px 1px #C5D2EF;
     border-radius: 4px 4px 4px 4px;
     padding: 16px 0 0 16px;
     background-color: #fff;
     margin-bottom: 20px;

     &:last-child {
       margin-bottom: 0;
     }

     .my-li-head {
       margin-bottom: 30px;
       display: flex;
       justify-content: space-between;

       .my-li-head-title {
         color: #393939;
         font-size: 14px;
         //  width: 230px; 
       }

       .my-li-head-title-img {
         position: relative;
         top: -11px;
         left: 0;
         margin-right: 5px;

         .my-li-head-title-img-1 {
           width: 69px;
           height: 30px;
         }

         .my-li-head-title-img-2 {
           width: 80px;
           height: 30px;

         }
       }
     }

     .my-li-time {
       display: flex;
       align-items: center;
       margin-top: 10px;
       height: 15px;

       .my-li-time-img {
         width: 14px;
         height: 14px;
         margin-right: 8px;
       }

       .my-li-time-name {
         color: #C1C3C7;
         font-size: 13px;
       }
     }

     .my-li-box {
       position: relative;
       display: flex;
       justify-content: flex-end;

       .my-li-box-item {
         position: relative;
         display: flex;
         align-items: center;
         padding: 8px;
         background-color: #F8F8F8;

         // border-right: 1px solid #DFDFDF;
         &::after {
           content: "";
           position: absolute;
           top: 8px;
           right: 0;
           width: 1px;
           height: 19px;
           background-color: #DFDFDF;
         }

         &:last-child::after {
           width: 0 !important;
         }

         .my-li-box-item-img {
           width: 13px;
           height: 13px;
           margin-right: 3px;
         }

         .my-li-box-item-name {
           color: #333333;
           font-size: 14px;
         }
       }
     }
   }
 }
</style>   